


































import {Vue, Component, Prop} from 'vue-property-decorator';
@Component
export default class AccumulationContentTop extends Vue {
  @Prop({required: false, default: true})
  private showForm!: boolean;
  private routeName: string = 'AccumulationConfiguration';

  private isExpand: boolean = false;
  private toggleAdvancedSearch(): void {
    this.isExpand = !this.isExpand;
  }
  private created(): void {
    this.checkTheRoute();
  }
  private checkTheRoute(): void {
    this.routeName = this.$route.name;
  }
}
